<template>
  <span v-if="configurationStatus" :class="status[configurationStatus]">
    {{ $t(`store.configuration_status.${configurationStatus}`) }}
  </span>
</template>

<script>
export default {
  props: {
    configurationStatus: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      status: {
        to_be_completed: "inline-flex items-center rounded-md bg-gray-200 px-2 py-1 text-xs",
        pending_validation: "inline-flex items-center rounded-md bg-yellow-200 px-2 py-1 text-xs",
        validated: "inline-flex items-center rounded-md bg-green-200 px-2 py-1 text-xs",
        rejected: "inline-flex items-center rounded-md bg-red-200 px-2 py-1 text-xs",
      },
    };
  },
};
</script>
